var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "draggable",
        _vm._b(
          {
            on: { start: _vm.onDragStart, end: _vm.onDragEnd },
            model: {
              value: _vm._questionList,
              callback: function ($$v) {
                _vm._questionList = $$v
              },
              expression: "_questionList",
            },
          },
          "draggable",
          _vm.dragOptions,
          false
        ),
        _vm._l(_vm.questionList, function (question, i) {
          return _c(
            question.questionType === "CHOICE"
              ? "TestbankQuestionChoice"
              : "TestbankQuestionSubjective",
            {
              key: i,
              tag: "component",
              attrs: {
                type: _vm.type,
                index: i,
                question: question,
                testbankObj: _vm.testbankObj,
              },
              on: { deleteQuestion: _vm.onDeleteQuestion },
            }
          )
        }),
        1
      ),
      _vm.isCreate || _vm.isCopy
        ? _c(
            "div",
            { staticClass: "pb-10 flex gap-x-2" },
            [
              _c(
                "GrmBtn",
                {
                  staticClass: "flex-1",
                  on: {
                    click: function ($event) {
                      return _vm.onAddQuestion("CHOICE")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("testBank.add.choice")))]
              ),
              _c(
                "GrmBtn",
                {
                  staticClass: "flex-1",
                  on: {
                    click: function ($event) {
                      return _vm.onAddQuestion("SUBJECTIVE")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("testBank.add.subjective")))]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }